export const formatDateAndTime = ( time ) => {
    let formattedTime = `${time[8]}${time[9]}:${time[10]}${time[11]}, ${time[6]}${time[7]}/${time[4]}${time[5]}/${time[0]}${time[1]}${time[2]}${time[3]}`
    if (time[0] === '1') {
      const interTime = `${new Date(parseInt(time, 10))}`
      formattedTime = interTime.slice(0, 21)
    }
    return formattedTime
  }
